export function valueToLabel(value, list = [], sperator = ",") {
  // eslint-disable-next-line no-undef
  // const type = getType(value)
  if (typeof value === "undefined" || value === null) return "";
  const type = value instanceof Array;
  if (!type) {
    value = [value];
  }

  return value
    .map(item => {
      const instance = list.find(child => child.value === item);
      return instance ? instance.label : item;
    })
    .join(sperator);
}

export function weekDifferenceSet(list = []) {
  //一周取差集
  let week = [1, 2, 3, 4, 5, 6, 7];
  if (typeof list === "undefined" || list === null) return "";
  return week.filter(x => [...list].every(y => y !== x));
}
export const escapeRegexpString = (value = "") =>
  String(value).replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
